export {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ctrl/tinycolor/dist/module/interfaces.js
// module id = 1852
// module chunks = 0